import type { StyledComponentProps } from '@material-ui/core';
import { Button, Card, Snackbar, Typography } from '@material-ui/core';
import { Alert } from '@mui/material';
import React, { useState } from 'react';
import WhatsAppLink from 'v2/components/Shared/WhatsAppLink';
import analyticsService from 'v2/services/analytics';

import type { AccountManager } from 'v2/interfaces/user';

import styles from './styles';

interface IProps extends StyledComponentProps {
  data: AccountManager;
}

function ManagerInfo({ classes, data }: IProps) {
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const photoSrc = data.photo ? data.photo : '/img/avatar-default.svg';

  async function handleCopyEmail(): Promise<void> {
    try {
      await navigator.clipboard.writeText(data.email);
      setOpenAlert(true);
      setAlertMessage('E-mail copiado.');

      analyticsService.sendEvent('Email Button Clicked', 'Dashboard - Account Manager');
    } catch (err) {
      setOpenAlert(true);
      setAlertMessage('Falha ao copiar E-mail!');
    }
  }

  function handleRedirectWhatsApp() {
    analyticsService.sendEvent('WhatsApp Button Clicked', 'Dashboard - Account Manager');
  }

  function handleClose(event?: React.SyntheticEvent | Event, reason?: string): void {
    if (reason === 'clickaway') return;
    setOpenAlert(false);
  }

  return (
    <>
      <Card elevation={0} square className={classes.card}>
        <div className={classes.infoContainer}>
          <img src={photoSrc} alt='icone gerente de conta' className={classes.managerIcon} />
          <div className={classes.personalInfo}>
            <Typography color='inherit' gutterBottom variant='h6' component='span' style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>
              {data.name}
            </Typography>
            <Typography color='textSecondary' variant='subtitle1' component='span' className={classes.fontDescriptionStyle}>
              Consultor de sucesso • 9h às 18h
            </Typography>
          </div>
        </div>
        <div className={classes.contactContainer}>
          <Button id='btn-copy-email' className={classes.contactButton} onClick={handleCopyEmail}>
            <img className={classes.icon} src='/img/icon-envelope.svg' alt='Icone E-mail' />
            <Typography color='inherit' gutterBottom variant='h6' component='span' className={classes.fontDescriptionStyle}>
              E-mail
            </Typography>
          </Button>
          {data.phone ? (
            <WhatsAppLink phone={data.phone} stylesProps={classes.whatsappLink}>
              <Button id='btn-redirect-whatsapp' className={classes.contactButton} onClick={handleRedirectWhatsApp} style={{ width: '100%' }}>
                <img className={classes.icon} src='/img/icon-whatsapp.svg' alt='Icone E-mail' />
                <Typography color='inherit' gutterBottom variant='h6' component='span' className={classes.fontDescriptionStyle}>
                  WhatsApp
                </Typography>
              </Button>
            </WhatsAppLink>
          ) : null}
        </div>
      </Card>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleClose} severity='success' sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default styles(ManagerInfo);
